import { render, staticRenderFns } from "./categoryAddEditModal.vue?vue&type=template&id=589e558b&scoped=true&"
import script from "./categoryAddEditModal.vue?vue&type=script&lang=js&"
export * from "./categoryAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e558b",
  null
  
)

export default component.exports